import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { SignalRNotificationService } from '../../services/signalR-notification.service';
import { AuthenticationService } from '../../services/authentication.service';
import { Subject, Subscription } from 'rxjs';
import { Http, Response, Headers } from '@angular/http';
import { Configuration } from '../../configurations/shared.config';
@Component({
    selector: 'panic-alert-list',
    templateUrl: './panic-alert-list.component.html'
})
export class PanicAlertListComponent implements AfterViewInit, OnDestroy {
    subscriptions: Subscription[] = [];

    panicList: any[] = [];

    constructor(private _signalRService: SignalRNotificationService, private ref: ChangeDetectorRef,
        private authenticationService: AuthenticationService, private _http: Http) {

        
    }

    ngAfterViewInit() {
        this.getPanics();
        this.subscriptions.push(this._signalRService.PanicReceived.subscribe((panicData: any) => {
            this.panicList.push(panicData);
            this.ref.detectChanges();
        }));

        this.subscriptions.push(this._signalRService.PanicResolved.subscribe((panicId: any) => {
            let index = this.panicList.findIndex(p => p.PanicId == panicId);

            if (index > -1) {
                this.panicList.splice(index, 1);
                this.ref.detectChanges();
            }
        }));
    }

    getCurretUserId() {
        return this.authenticationService.staffId;
    }

    getPanics() {
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.PanicList).map(response => response.json())
            .subscribe(response => {
                if (!response.IsErrorState && response.Value) {
                   // console.log(response.Value)
                    this.panicList= response.Value;
                    this.ref.detectChanges();
                }
                else {
                }
            },
                error => {
                   
                });

    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PanicAlert/panic-alert-list.component.ts